import React from "react";
import {AlertTooltip} from "./AlertTooltip";
import {ALLOCATED_AMOUNT_GOAL, PERCENTAGE_GOAL} from "../../../../elements/BudgetPartialGoalsConfiguration";
import {DatetimeHelper} from "../../../../../utils/DatetimeHelper";
import {BU_PERIOD_TEMPORARY} from "../../../../../periods";
import {DAILY_RANGE_ENTRY_MODE_RANGE} from "../../../../../utils/BudgetHelper";

export class BudgetCellTooltip extends AlertTooltip {
    render() {
        return (
            <div className="alert-tooltip">
                <div className="alert-tooltip-body">
                    <div className="alert-tooltip-header">
                        <div className="col-12 m-0 p-0"><p
                            className="alert-tooltip-title">PRESUPUESTOS POR TRAMOS<span></span>
                        </p></div>
                    </div>
                    {this.partialGoalsContent()}
                </div>
            </div>
        )
    }

    partialGoalsContent() {
        return (
            <div className="alert-tooltip-content">
                <p className="alert-tooltip-description">
                    <ul>
                        {this.isDailyRangeMode() ? this.renderDailyRangeItems() : this.renderCumulativeItems()}
                    </ul>
                </p>
            </div>
        );
    }

    isDailyRangeMode() {
        const def = this.props.inputDefinition;
        return def && Array.isArray(def.entries) && def.entries.length > 0;
    }

    renderDailyRangeItems() {
        // Mostramos lo que el usuario ingresó (spike days y rangos), no las cumulative rows derivadas.
        const entries = this.props.inputDefinition.entries
            .slice()
            .sort((a, b) => {
                const aDate = a.mode === DAILY_RANGE_ENTRY_MODE_RANGE ? a.date_from : a.date;
                const bDate = b.mode === DAILY_RANGE_ENTRY_MODE_RANGE ? b.date_from : b.date;
                return parseInt(aDate, 10) - parseInt(bDate, 10);
            });
        return entries.map((entry, index) => {
            const amount = this.formatCurrency(entry.amount);
            if (entry.mode === DAILY_RANGE_ENTRY_MODE_RANGE) {
                const from = this.formatTooltipDate(entry.date_from);
                const to = this.formatTooltipDate(entry.date_to);
                return <li key={index}>{`${amount} cada día — del ${from} al ${to}`}</li>;
            }
            const date = this.formatTooltipDate(entry.date);
            return <li key={index}>{`${amount} — el día ${date}`}</li>;
        });
    }

    renderCumulativeItems() {
        const items = [];
        this.props.partialGoals.sort((a, b) => {
            return parseInt(a.date) - parseInt(b.date);
        }).forEach(partialGoal => {
            const date = this.formatTooltipDate(partialGoal["date"]);
            if(partialGoal["type"] === ALLOCATED_AMOUNT_GOAL) {
                const percentage = partialGoal["value"] / this.props.totalBudget*100;
                const percentageAsString = `${percentage.toFixed(0)}%`;
                const valueAsString = this.formatCurrency(partialGoal["value"]);
                items.push(this.renderPartialGoalSubItem(date, valueAsString, percentageAsString));
            }

            if(partialGoal["type"] === PERCENTAGE_GOAL) {
                const percentageAsString = `${partialGoal["value"]}%`;
                const valueAsString = this.formatCurrency(partialGoal["value"]*this.props.totalBudget/100, percentageAsString);
                items.push(this.renderPartialGoalSubItem(date, valueAsString, percentageAsString));
            }
        });

        return items;
    }

    formatTooltipDate(yyyymmdd) {
        return this.props.periodType === BU_PERIOD_TEMPORARY
            ? DatetimeHelper.YYYYMMDDToFriendlyStr(yyyymmdd)
            : DatetimeHelper.YYYYMMDDToDay(yyyymmdd);
    }

    formatCurrency(amount) {
        // La moneda es la de la línea de control. Estaba hardcodeada en USD, así que a toda
        // agencia que no factura en dólares el tooltip le mostraba otra moneda (card 0juTriFx).
        const currency = this.props.currency;
        if (!currency) {
            return new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }).format(amount);
        }
        try {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: currency,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }).format(amount);
        } catch (e) {
            // Código de moneda no soportado por Intl: mostramos el número con el código al lado.
            return `${new Intl.NumberFormat('en-US', {maximumFractionDigits: 0}).format(amount)} ${currency}`;
        }
    }

    renderPartialGoalSubItem(date, money, percentage) {
        return <li>{money} ({percentage}) al día {date}</li>;
    }
}
